import { render, staticRenderFns } from "./notification-rule-editor.vue?vue&type=template&id=8d78f838&scoped=true"
import script from "./notification-rule-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./notification-rule-editor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./notification-rule-editor.vue?vue&type=style&index=0&id=8d78f838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d78f838",
  null
  
)

export default component.exports